import axios from 'axios';

const vimeoaxios = (vimeotoken, customHeaders) =>
  axios.create({
    baseURL: 'https://api.vimeo.com/',
    headers: {
      Authorization: `Bearer ${vimeotoken}`,
      ...customHeaders,
    },
  });

export default vimeoaxios;
